import Echart from "echarts-for-react"
import { useMemo } from "react"
import { overviewStore } from "../../overview-store"
import useIsMobile from "@/hooks/use-is-mobile"

const ResourceTrendMiniChart = ({
  color = "#3B82F6",
  xAxisLabels = [],
  data = [],
  min = 0,
  max = 0,
  unit = ""
}) => {
  const isMobile = useIsMobile()
  const { resetKeyMap } = overviewStore()

  const option = useMemo(() => {
    const lastIndex = xAxisLabels.length - 1
    const middleIndex = Math.floor(xAxisLabels.length / 2)
    return {
      // animation: false,
      grid: {
        top: 10,
        left: 2,
        right: 12,
        bottom: 20
      },

      tooltip: {
        trigger: "axis",

        backgroundColor: "rgba(255,255,255,0.96)",
        borderColor: "#E2E8F0",
        borderWidth: 1,

        textStyle: {
          color: "#1E293B",
          fontSize: 11
        },

        formatter: (params) => {
          const item = params[0]

          return `
            <div style="font-weight:600;margin-bottom:2px">
              ${item.name}
            </div>

            <div>
              ${Number(item.value).toLocaleString()}${unit}
            </div>
          `
        }
      },

      xAxis: {
        type: "category",

        boundaryGap: false,

        data: xAxisLabels,

        axisLine: {
          show: true,

          lineStyle: {
            color: "#F1F5F9"
          }
        },

        axisTick: {
          show: false
        },

        axisLabel: {
          color: "#94A3B8",

          fontSize: 10,

          margin: 10,

          interval: (index) => {
            return index === 0 || index === middleIndex || index === lastIndex
          }
        }
      },

      yAxis: {
        type: "value",
        show: false,
        min: min * 0.95,
        max: max * 1.05
      },

      series: [
        {
          type: "line",

          data,

          smooth: false,

          symbol: "circle",

          symbolSize: (value, params) => {
            return params.dataIndex === lastIndex ? 6 : 4
          },

          lineStyle: {
            color,
            width: 1.5
          },

          itemStyle: {
            color: "#fff",
            borderColor: color,
            borderWidth: 1.8
          },

          areaStyle: {
            color,
            opacity: 0.025
          }
        }
      ]
    }
  }, [color, data, min, max, unit, xAxisLabels])

  return (
    <Echart
      option={option}
      key={resetKeyMap["trend"]}
      style={{
        width: "100%",
        height: "100%",
        minHeight: isMobile ? 80 : 130,
        maxHeight: 150,
        minWidth: 0
      }}
    />
  )
}

export default ResourceTrendMiniChart
